export const MerchantsColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Маркетплейс',
        key: 'marketplace_name',
    },
    {
        name: 'Токен',
        key: 'token',
    },
]
